module.exports = __webpack_public_path__ + "static/media/infoJumbo1.0c5176a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/sllaser/images/infoJumbo1.jpg
// module id = 544
// module chunks = 0